import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import EvaluationAcceptServices from "./EvaluationAccept.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getEvaluationAccept = (token) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_ACCEPT,
      payload: true,
    });
    const resp = await EvaluationAcceptServices.getEvaluationAccept(token);
    dispatch({
      type: actions.GET_EVALUATION_ACCEPT,
      payload: resp.data,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 401:
            message = messages.evaluationNotAvailable;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_ACCEPT,
      payload: false,
    });
  }
};

export const getEvaluationAcceptById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_ACCEPT,
      payload: true,
    });
    const resp = await EvaluationAcceptServices.getEvaluationAcceptById(id);
    dispatch({
      type: actions.GET_EVALUATION_ACCEPT,
      payload: resp.data,
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 401:
            message = messages.evaluationNotAvailable;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_ACCEPT,
      payload: false,
    });
  }
};

export const saveEvaluationAccept = (data, token) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_EVALUATION_ACCEPT,
      payload: true,
    });
    await EvaluationAcceptServices.saveEvaluationAccept(data,token);
    // const resp = await EvaluationAcceptServices.editEvaluationAccept(id, data);
    // dispatch({
    //   type: actions.GET_EVALUATION_ACCEPT,
    //   payload: resp.data,
    // });
    dispatch({
      type: actions.FORM_FAIL,
      payload: messages.evaluationNotAvailable,
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 401:
            message = "La evaluacion ya no esta disponible";
            break;
          case 403:
            message = messages.accessMessage;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_EVALUATION_ACCEPT,
      payload: false,
    });
  }
};
